import AlchemyModal, { ModalHeader } from 'UIKit/AlchemyModal'
import Button from 'UIKit/Button/Button'
import BackgroundImage from 'UIKit/Image/BackgroundImage'
import { ModalProps } from 'UIKit/Modal/Modal'
import Text from 'UIKit/Text/Text'
import { RouteConfig } from 'config/constants/route'
import { WageringConditionBonus } from 'config/types/bonus/userBonus'
import { useCloseAllModal } from 'hooks/useModal'
import { useRouter } from 'hooks/useRouter'
import Column, { ColumnCenter } from 'layout/Components/Column'
import { RowCenter } from 'layout/Components/Row'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'
import theme from 'theme'
import { ModalColorTheme } from 'theme/modal/colors'
import { getFullDisplayBalance } from 'utils/formatBalance'

interface RewardAdventureBonusModalProps {
  bonus: WageringConditionBonus
  rank: number
}

const RewardAdventureBonusModal: React.FC<ModalProps<RewardAdventureBonusModalProps>> = ({
  onDismiss,
  data: { bonus, rank },
}) => {
  const router = useRouter()
  const { t } = useTranslation()
  const closeModal = useCloseAllModal()
  const rewardAmount = bonus?.bonusAmount
    ? `${getFullDisplayBalance(bonus.bonusAmount.amount, 0)} ${bonus.bonusAmount.token.name}`
    : ''

  return (
    <StyledModal
      onDismiss={onDismiss}
      minWidth={['', '', '', '620px !important']}
      colorTheme={ModalColorTheme.Darkblue}
      p="0px !important"
      background="none !important"
    >
      <BackgroundImage src="/images/wager-adventure/adventure-bonus-top-level.png" width="100%" paddingBottom={440}>
        <ModalHeader colorTheme={ModalColorTheme.Darkblue} p="20px" />

        <RowCenter position="absolute" top={0} right={0} bottom={0} left={0}>
          <ColumnCenter p={['20px', '', '32px', '', '40px']}>
            <Text fontSize={['16px', '', '20px']}>
              <Trans>Congratulations</Trans>
            </Text>
            <Text
              mt="8px"
              fontSize={['24px', '', '28px', '', '32px']}
              lineHeight={1.2}
              fontWeight={700}
              color="text"
              textAlign="center"
            >
              <Trans
                i18nKey={'topRewardAdventure'}
                values={{
                  rank,
                }}
                components={{
                  highlight_tag: (
                    <Text
                      mx="2px"
                      as="span"
                      fontSize={['24px', '', '28px', '', '32px']}
                      lineHeight={1.2}
                      fontWeight={700}
                      color="warning"
                    />
                  ),
                }}
              />
            </Text>

            <Column my={['24px', '', '32px']}>
              {rewardAmount && (
                <Text mb="8px" fontWeight={700} fontSize={['16px', '', '20px']} color="text" textAlign="center">
                  {t('Congratulations on receiving {{ rewardAmount }}', {
                    rewardAmount,
                  })}
                </Text>
              )}

              <Text fontSize={['12px', '12px', '14px']} color="textTertiary" textAlign="center" lineHeight={1.4}>
                <Trans>
                  A great reward is waiting for you, a worthy recognition for your efforts to overcome all the
                  challenges and reach the final destination. Keep exploring and showcasing your remarkable talents in
                  the upcoming season!
                </Trans>
              </Text>
              <Text fontSize={['12px', '12px', '14px']} color="textTertiary" textAlign="center" lineHeight={1.4}>
                <Trans>Prizes will be added to the Bonus Center within 24 hours.</Trans>
              </Text>
            </Column>

            <Button
              width="320px"
              height="48px"
              style={{
                borderRadius: theme.radii.tiny,
              }}
              onClick={() => {
                router.push(RouteConfig.BonusCenter)
                closeModal()
              }}
            >
              <Text fontWeight={700} fontSize="14px">
                <Trans>Go to Bonus Center</Trans>
              </Text>
            </Button>
          </ColumnCenter>
        </RowCenter>
      </BackgroundImage>
    </StyledModal>
  )
}

const StyledModal = styled(AlchemyModal)`
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  ${({ theme: { mediaQueries } }) => mediaQueries.sm} {
    border-radius: ${({ theme }) => theme.radii.extraLarge} !important;
  }
`

export default RewardAdventureBonusModal
